<template>
    <div>
        上传组件
        <img-upload :imgList="imgList" @upLoadImg="upLoadImg" @deleteImg="deleteImg"></img-upload>

    </div>
</template>
<script>
import imgUpload from "@/components/public/imgUpload"
export default {
    components:{
        imgUpload
    },
    data(){
        return{
            imgList:[],
        }
    },
    methods:{
        upLoadImg(data){
            console.log(data)
            data.map(item=>{
                this.imgList.push({
                    Code:item.data.data.Code,
                    ImgUrl:item.data.data.ImgUrl
                })
            })
        },
        deleteImg(item){
            this.imgList.splice(item.index,1)
        }
    }
}
</script>
<style lang="scss" scoped>

</style>